module.exports = __webpack_public_path__ + "img/logo_water.7dbf22c5.png";